// The process page's side panel: its tabs, the findings on the Overview, and the readings each
// analysis tab adds. Other languages fall back to these strings until they are translated.
export const processPanelEnglish = {
  tabsLabel: "Process details",
  tab_overview: "Overview",
  tab_cases: "Cases",
  tab_steps: "Steps",
  tab_apps: "Apps",
  backTo_overview: "Back to the overview",
  backTo_cases: "Back to cases",
  backTo_steps: "Back to steps",
  backTo_apps: "Back to apps",

  noticedTitle: "What Platonic noticed",
  noticedPosition: "{{current}} of {{total}}",
  noticedPrevious: "Previous finding",
  noticedNext: "Next finding",
  noticedAsk: "Ask about this",
  noticedAskPrompt:
    "In {{process}}, Platonic noticed: {{finding}} {{detail}} Why is this happening, and what could be done about it?",
  noticed_waits: "Cases spend {{share}}% of their time between steps.",
  noticed_waits_detail:
    "A typical case is {{work}} of work spread over {{elapsed}}. Review the largest gaps for follow-up opportunities; gaps can include other work or time outside working hours.",
  noticed_timeSink: "“{{step}}” is the biggest time-consuming step.",
  noticed_timeSink_detail:
    "It represents {{share}}% of this process's time. Review its repeated actions for opportunities to simplify the work.",
  noticed_branching: "“{{step}}” has {{count}} different next steps.",
  noticed_branching_detail:
    "Compare the common branches to understand which differences are necessary.",
  noticed_rework: "{{share}}% of cases come back to a step they already did.",
  noticed_rework_detail:
    "“{{step}}” is where cases return most often. Review those returns for missing information or repeated checks; some returns may be necessary.",
  noticed_spread: "Case duration varies widely.",
  noticed_spread_detail:
    "The longest case took {{max}}, {{ratio}}× the median of {{median}}. Compare its steps with typical cases to identify the extra work.",
  noticed_dominantPath: "Most cases ({{share}}%) do the same set of steps.",
  noticed_dominantPath_detail_one:
    "The rest follow {{count}} other path. Compare the differences before deciding whether a shared approach would help.",
  noticed_dominantPath_detail:
    "The rest spread over {{count}} other paths. Compare the differences before deciding whether a shared approach would help.",
  noticed_noDominantPath: "No single path dominates this process.",
  noticed_noDominantPath_detail:
    "The most common set of steps covers only {{share}}% of cases. Compare case types to see whether they need different workflows.",
  noticed_handoffs: "{{share}}% of cases move repeatedly between steps in {{from}} and {{to}}.",
  noticed_handoffs_detail:
    "Observed in {{cases}} of {{total}} cases, with a median of {{switches}} moves between these apps in those cases. Review the handoffs for repeated data entry or checks.",
  noticedView_apps: "View apps",
  noticed_app: "Most of the work in this process happens in {{app}}.",
  noticed_app_detail: "{{share}}% of the time in apps, used in {{cases}} of {{total}} cases.",
  noticedView_step: "View step",
  noticedView_usualSteps: "View usual steps",
  noticedView_cases: "View cases",

  metricCases: "Cases",
  metricAvgDuration: "Avg. work time",
  metricMedian: "Median",
  metricStepsPerCase: "Steps / case",
  metricWorkTime: "Work time",
  metricWorkTimeHelp:
    "Median time spent on a case's steps. Pauses between one step and the next are not counted.",
  metricStartToFinish: "Start to finish",
  metricStartToFinishHelp:
    "Median time from a case's first step starting to its last step ending, pauses included.",
  usualSteps: "How work usually happens",
  usualStepsDescription:
    "Common steps. An arrow means most cases that do both steps do them in that order.",
  usualStepsUnordered:
    "Common steps, most common first. They rarely happen in the same case, so there's no usual order.",
  noUsualSteps: "No step shows up in 10% of cases or more: these cases rarely do the same work.",
  whereTimeGoes: "Where time goes",
  whereTimeGoesDescription:
    "Recorded activity in steps, and elapsed gaps between consecutive steps. Gaps can include other work and time outside working hours.",
  workBreakdownDescription:
    "{{total}} total work across selected cases. Each percentage is a share of all step work time.",
  waitBreakdownDescription:
    "{{total}} between steps across selected cases. Each percentage is a share of all time between steps; average gap is per transition occurrence.",
  columnAvgWait: "Avg. gap",
  askAboutGap: "Ask about time between {{from}} and {{to}}",
  timeWorking: "Working {{share}}%",
  timeWaiting: "Between steps {{share}}%",
  showAllSteps: "Show all {{count}} steps",
  showAllWaits: "Show all {{count}} gaps",
  viewAllSteps: "View all steps",
  viewWaits: "View gaps",

  caseSession: "Session",
  caseActiveTime: "Active time",
  caseEvidence: "Evidence",
  caseScreenshots_one: "View 1 screenshot",
  caseScreenshots: "View {{count}} screenshots",
  caseTimeline: "Case timeline",
  caseStepPosition: "Step {{current}} of {{total}}",
  casePreviousStep: "Previous step",
  caseNextStep: "Next step",
  caseGap: "{{duration}} gap",
  caseOccurrence: "Occurrence {{current}} of {{total}} in this case",
  caseAskStep: "Ask about this step",
  caseObjects: "Related objects ({{count}})",
  caseFindingSteps: "View {{count}} supporting steps",
  caseFindings: "What stands out",
  caseViewStep: "View step {{number}}",
  casePath: "Path for this case",
  caseStepPrompt:
    "Explain what happened in step {{number}}, “{{step}}”, of this case. Case description: {{name}}",
  caseGapPrompt:
    "What does the recorded evidence show about the {{duration}} gap before step {{number}}, “{{step}}”, in this case? Case description: {{name}}",

  casesIntro:
    "Each case is one observed execution of this process: how long it took, and what made it different.",
  metricTotalCases: "Total cases",
  scopeHelp: "Applies to the graph and all tabs.",
  editFilters: "Edit filters",
  aiFilter: "AI filter",
  caseActions: "Case actions",
  allCasesFilter: "All",
  caseCharts: "Case work time charts",
  caseDuration: "Case work time",
  caseWorkTimeHelp: "Time spent working on the case's steps, excluding waits between steps.",
  caseList: "Cases",
  trendNeedsCases: "Cases recorded at different times are needed to show a trend.",
  chooseCases: "Choose cases…",
  chooseCasesHelp: "Choose which cases to show in the graph.",
  selectCase: "Select {{label}}",
  selectAllMatching: "Select all {{count}} matching cases",
  clearSelection: "Clear selection",
  hiddenSelections_one: "{{count}} chosen case is hidden by the search or quick filters.",
  hiddenSelections: "{{count}} chosen cases are hidden by the search or quick filters.",
  showCasesInGraph_one: "Show {{count}} case in graph",
  showCasesInGraph: "Show {{count}} cases in graph",
  graphLabel: "Graph:",
  graphSimplified: "Simplified",
  graphSimplifiedCases: "{{count}} of {{total}} cases",
  graphSimplifiedExample: "1 example of {{total}} cases",
  graphAllPaths: "All paths",
  graphAllPathsCases_one: "{{count}} case",
  graphAllPathsCases: "{{count}} cases",
  graphChosenCases_one: "{{count}} chosen case",
  graphChosenCases: "{{count}} chosen cases",
  graphHelpLabel: "About the graph",
  graphSimplifyHelp:
    "Simplified shows a selection of the most common cases, so the map is easier to read. Large maps open this way. The numbers on the map, KPIs, the case list and the tabs still count every case in scope.",
  showAllPaths: "Show all",
  simplifyGraph: "Simplify",
  clearGraphCases: "Show all",
  graphSingleCaseSummary: "Showing the only matching case.",
  shownInGraph: "Shown in graph",
  casesInGraph: "{{count}} in graph",
  metricMedianDuration: "Median work time",
  caseDistribution: "Distribution",
  caseDistributionDescription:
    "Each bar counts cases in that work time range, excluding waits between steps. The dashed line marks the threshold for unusually long work time, calculated before work time filtering.",
  histogramHelp: "How to use the duration chart",
  histogramSelectedRange: "Selected: {{from}} – {{to}}",
  histogramSelectedMinimum: "Selected: {{from}} or longer",
  histogramClearRange: "Clear range",
  simplifyAbove: "Simplify above",
  autoSimplifyHelp:
    "Automatically shows common paths above {{stepLimit}} or {{transitions}} transitions (5× steps). All cases remain included. Use Show all to see every path.",
  simplifyStepUnit: "steps",
  simplifyStepUnit_one: "step",
  histogramResetZoom: "Reset zoom",
  histogramDragCount: "{{count}} {{label}}",
  histogramHintSelect:
    "Click a bar to select its duration range, or drag across the chart to select a wider range. Hold ⌘ or Ctrl and scroll to zoom.",
  histogramHintZoom:
    "Click a bar or drag horizontally to zoom into a duration range. Hold ⌘ or Ctrl and scroll to zoom around the pointer; scroll sideways to move along. Use Reset zoom or double-click to restore the full range.",
  fastest: "Fastest",
  slowest: "Slowest",
  unusuallyLongCases: "Unusually long cases",
  outliersCount_one: "{{count}} case ({{share}}%)",
  outliersCount: "{{count}} cases ({{share}}%)",
  outliersDetailPrefix: "took unusually long: more than",
  outliersDetailSuffix: "of work",
  showOutliers: "Show these cases",
  histogramOutlierThreshold: ">{{threshold}}",
  histogramSelection: "Cases from {{from}} to {{to}}",
  trendGroupBy: "Group by",
  trendGroup_day: "Day",
  trendGroup_week: "Week",
  trendGroup_month: "Month",
  trendAria: "Trend over time: median duration by {{grouping}}",
  trendWeekOf: "Week of {{date}}",
  trendTooltip_one: "{{period}} · {{median}} median · {{count}} case",
  trendTooltip: "{{period}} · {{median}} median · {{count}} cases",
  trendMedian: "Median",
  trendEmpty: "No {{unit}}",
  trendZoomHelp:
    "Drag a box to zoom into both time and duration. Double-click to reset zoom. This changes the chart view, not the cases in scope. Press Escape to cancel a drag, or reset the zoom when no drag is active.",
  subset_all: "All cases",
  subset_longest: "Longest",
  subset_waits: "With waits",
  subset_variations: "With variations",
  subset_rework: "With returns",
  subsetHelp_all: "Every case in scope.",
  subsetHelp_longest: "The slowest quarter of the cases.",
  subsetHelp_waits:
    "Paused between two steps for longer than a typical case takes to do all of its work.",
  subsetHelp_variations: "Include more rarely seen steps than the typical case does.",
  subsetHelp_rework: "Come back to steps they had already left, more often than the typical case.",
  searchCases: "Search cases…",
  pathFilter: "Cases: {{label}}",
  clearFilter: "Clear filter",
  columnCase: "Case",
  columnDuration: "Work time",
  columnNotes: "Key notes",
  pill_wait: "Longest gap: {{duration}}",
  pill_rework: "Return to an earlier step",
  pill_reworkMany: "{{count}} returns to earlier steps",
  pill_variation: "Unusual step",
  pill_variationMany: "{{count}} unusual steps",
  pill_app: "Used {{app}}",
  pill_steps: "{{count}} steps",
  noteTitle_longWait: "Long wait",
  noteTitle_wait: "Wait",
  noteBody_wait: "Paused {{duration}} before “{{step}}” started.",
  noteContext_longWait:
    "Among the longest waits in this process. A typical case takes {{typical}} of work in total.",
  noteContext_wait:
    "Longer than a typical case takes to do all of its work ({{typical}}), though not unusual here.",
  noteTitle_rework: "Returns to earlier steps",
  noteBody_rework_one: "Came back to “{{step}}” after moving on to other work.",
  noteBody_rework: "Came back to earlier steps {{count}} times, mostly “{{step}}”.",
  noteContext_reworkNone: "Most cases never come back to a step they have left.",
  noteContext_rework_one: "The typical case comes back once.",
  noteContext_rework: "The typical case comes back {{count}} times.",
  noteTitle_variation: "Unusual path",
  noteBody_variation: "Includes “{{step}}”, done in only {{count}} of {{total}} cases.",
  noteContext_variation_one: "It also includes 1 other rarely seen step.",
  noteContext_variation: "It also includes {{count}} other rarely seen steps.",
  noteTitle_app: "Different app",
  noteBody_app: "Worked in {{app}}, which only {{count}} of {{total}} cases use.",
  noteTitle_steps: "Many steps",
  noteBody_steps: "{{count}} steps, where the typical case takes {{typical}}.",
  note_standard: "Standard flow",
  noteBody_standard: "Nothing in this case stands out from the other cases in scope.",
  noteMore: "+{{count}}",
  noteMoreLabel_one: "1 more note",
  noteMoreLabel: "{{count}} more notes",
  legendTitle: "What the colours mean",
  legend_delay: "Long delay",
  legend_attention: "Returns to earlier steps",
  legend_variation: "Unusual path",
  legend_info: "Other difference",
  legendDurationLabel: "Red duration:",
  legendDuration: "far outside this process's usual range",
  outlierDuration: "Far longer than usual for this process (over {{threshold}})",
  noMatchingCases: "No cases match these filters.",
  openCase: "Open {{label}}",
  pagination: "Pages",
  pageRange: "{{from}}–{{to}} of {{total}}",
  previousPage: "Previous page",
  nextPage: "Next page",

  stepList: "Browse steps",
  metricUniqueSteps: "Unique steps",
  metricAvgStepDuration: "Avg. step",
  metricTotalActive: "Active time",
  stepDistribution: "Step duration distribution",
  stepDistributionHelp:
    "Active time spent on each step occurrence across the cases in scope, excluding waits between steps.",
  searchSteps: "Search steps…",
  stepRangeFilter: "Taking {{from}} to {{to}}",
  stepTypeTime: "Time by step type",
  stepTypeTimeHelp: "Share of active time spent on each type of step across the cases in scope.",
  stepTypeFilter: "Type: {{type}}",
  allApps: "All apps",
  frequency_all: "All steps",
  frequency_frequent: "Frequent steps",
  frequency_rare: "Rare steps",
  frequencyLabel: "How often",
  columnStep: "Step",
  columnApps: "Apps",
  columnAvg: "Avg.",
  columnCasesWithStep: "Cases",
  columnTotal: "Total",
  columnBranches: "Branches",
  columnBranchesHelp:
    "How many different steps cases go to next. Steps with many branches are where the process splits.",
  sortBy: "Sort by {{column}}",
  noMatchingSteps: "No steps match these filters.",
  openStep: "Open {{step}}",

  transitionFrom: "From",
  transitionTo: "To",
  transitionCount: "Transitions",
  transitionCaseDuration: "Duration",
  transitionScope: "Across {{count}} cases in the current analysis scope.",
  transitionDepartures: "{{count}} of {{total}} departures from this step take this route.",
  transitionWaitCoverage:
    "Based on timing data for {{count}} of {{total}} transitions. Wait is the pause between steps, not active work.",
  transitionWaitCoverage_one:
    "Based on timing data for {{count}} transition. Wait is the pause between steps, not active work.",
  transitionNoTiming: "No timing data is available for this transition.",
  transitionTerminalTiming:
    "Wait time is measured between two observed steps; it does not apply to the start or end of a case.",
  transitionNotApplicable: "N/A",
  transitionCasesHint:
    "Durations below are for the whole case. Open a case at this transition to inspect its steps.",
  transitionAsk: "Ask about this transition",

  stepScope:
    "Across {{count}} cases in the current analysis scope. Graph path settings only simplify the map.",
  stepTotalTime: "Total active time",
  stepCasesOrder: "Most recent first",
  stepOccurrences_one: "1 occurrence",
  stepOccurrences: "{{count}} occurrences",
  stepCaseTime: "{{duration}} on this step",
  stepCasesHint:
    "Occurrences and time below refer only to this step. Bars compare time across these cases. Expand a case to inspect its evidence.",
  stepAllCases: "Show all {{count}} cases",
  stepOpenCase: "Open case",
  stepInspectCase: "Inspect this case",
  stepInspectOccurrences: "Inspect repeated occurrences",
  stepConcentration: "One case accounts for {{pct}}% of this step’s time",
  stepConcentrationDetail: "{{duration}} across {{count}} occurrences in that case.",
  stepConcentrationDetail_one: "{{duration}} in one occurrence in that case.",
  stepRepeated: "Repeated in {{count}} of {{total}} cases",
  stepRepeatedDetail:
    "These cases contain more than one occurrence. Repetition alone does not imply rework.",
  stepSequence: "Previous and next steps",
  stepPrevious: "Previous steps",
  stepSequenceSummary: "{{previous}} previous · {{next}} next",
  stepDurationSummary: "Median {{median}} · Range {{min}}–{{max}}",
  stepAppsSummary: "{{app}} · {{pct}}% share",
  stepTypes: "Step types",
  stepTypesSummary: "{{type}} · {{pct}}% share",
  stepTransitionsHelp:
    "Shares count recorded transitions, not unique cases. Repeats stay visible in both directions.",
  stepArrivals_one: "1 arrival",
  stepArrivals: "{{count}} arrivals",
  stepDepartures_one: "1 departure",
  stepDepartures: "{{count}} departures",
  stepTransitionCount_one: "1 transition",
  stepTransitionCount: "{{count}} transitions",
  stepTransitionCases_one: "1 case",
  stepTransitionCases: "{{count}} cases",
  stepTransitionWait: "{{duration}} average gap",
  stepNoTransitions: "No recorded transitions in this direction.",
  stepAllPrevious: "Show all {{count}} previous steps",
  stepAllNext: "Show all {{count}} next steps",
  stepAskTransition: "Ask about transition",
  stepApp: "App",
  stepAppTime: "Total time",
  stepAppShare: "Share",
  stepOtherApps: "Other / unattributed",
  stepOtherAppsHelp:
    "Share of total app time across occurrences of this step. Other / unattributed includes apps below 0.5% and time without an app attribution. Overlapping app time is included in the share denominator.",
  stepAllApps: "Show all {{count}} app rows",
  durationScope: "Active time per occurrence, excluding gaps between steps.",
  durationDistribution: "Duration distribution",
  durationDistributionHelp: "Each bar counts {{unit}} in that duration range.",
  durationTrendHelp:
    "Median duration for each period. Dashed lines bridge periods with no observations.",
  durationNoTrend: "A time trend needs observations on more than one date.",
  trendSampleTooltip: "{{period}} · {{median}} median · {{unit}}: {{count}}",
  stepAskPrompt: "Explain the observed patterns and evidence for “{{step}}” in {{process}}.",
  ofArrivals: "{{pct}}% of arrivals",
  ofDepartures: "{{pct}}% of departures",
  caseStart: "Start of the case",
  caseEnd: "End of the case",

  branchRepeats: "Repeats this step",

  nodeVolume_one: "{{count}} case · {{share}}%",
  nodeVolume: "{{count}} cases · {{share}}%",
  nodeTotalTime: "{{duration}} total",

  metricAppsUsed: "Apps used",
  metricTimeInApps: "Time in apps",
  metricTimePerCase: "Per case",
  metricMainApp: "Main app",
  timeByApp: "Time spent by application",
  columnApp: "Application",
  columnTime: "Time",
  columnShare: "Share",
  columnCasesUsing: "Cases",
  columnSteps: "Steps",
  columnStepsHelp: "Steps the application is a real part of — at least a tenth of the step's time.",
  otherAppsHelp: "Each accounts for less than 0.5% of time in apps.",
  highlightApp: "Highlight the steps done in {{app}} on the map",
  noApps: "No application time was recorded for these cases.",
};
